import { render, staticRenderFns } from "./CriteriaInput.vue?vue&type=template&id=16b7c742"
import script from "./CriteriaInput.vue?vue&type=script&lang=ts"
export * from "./CriteriaInput.vue?vue&type=script&lang=ts"
import style0 from "./CriteriaInput.vue?vue&type=style&index=0&id=16b7c742&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports